import { size } from "lodash";
import PropTypes from "prop-types";
import React, { createContext, useEffect, useState } from "react";
import { Snackbar } from "components/Snackbar";

export const SnackbarQueueContext = createContext({
  addSnackbarToQueue: _snackbarConfig => {}
});
SnackbarQueueContext.displayName = "SnackbarQueueContext";

export const SnackbarQueueProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [snackbarQueue, setSnackbarQueue] = useState([]);
  const [activeSnackbar, setActiveSnackbar] = useState();

  useEffect(() => {
    if (size(snackbarQueue) > 0 && !open && !activeSnackbar) {
      setActiveSnackbar({ ...snackbarQueue[0] });
      setSnackbarQueue(prev => prev.slice(1));
      setOpen(true);
    }
  }, [activeSnackbar, open, snackbarQueue]);

  const addSnackbarToQueue = snackbarConfig =>
    setSnackbarQueue(prev => [...prev, snackbarConfig]);

  const onCloseSnackbar = () => {
    setOpen(false);
    setTimeout(() => {
      setActiveSnackbar();
    }, 100);
  };

  return (
    <SnackbarQueueContext.Provider
      value={{
        addSnackbarToQueue
      }}
    >
      {children}
      <Snackbar open={open} onClose={onCloseSnackbar} {...activeSnackbar}>
        {activeSnackbar?.message}
      </Snackbar>
    </SnackbarQueueContext.Provider>
  );
};

SnackbarQueueProvider.propTypes = {
  children: PropTypes.node
};
